import type { NDateLocale } from './enUS'
import { ko } from 'date-fns/locale'

const dateKoKR: NDateLocale = {
  name: 'ko-KR',
  locale: ko
}

export default dateKoKR
